import gql from 'graphql-tag';

import type { BlogPostBuilderBrief, KeywordData } from 'src/data/blog';
import { executeGqlMutation, type GqlCallVariables } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { parseJson, stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_BLOG_POST_BUILDER_BRIEF } from './schema';

const MUTATION = gql`
  mutation UpdateBlogPostBuilderKeywords(
    $id: ID!
    $keywords: [String!]!
    $targetKeywords: [String!]!
    $supportingKeywords: JSON
  ) {
    updateBlogPostBuilderKeywords(
      id: $id
      keywords: $keywords
      targetKeywords: $targetKeywords
      supportingKeywords: $supportingKeywords
    ) {
      ...BlogPostBuilderBrief
    }
  }
  ${FRAGMENT_BLOG_POST_BUILDER_BRIEF}
`;

interface Variables extends GqlCallVariables {
  id: ID;
  keywords: string[];
  targetKeywords: string[];
  supportingKeywords?: KeywordData[];
}

interface Response extends Omit<BlogPostBuilderBrief, 'supportingKeywords'> {
  supportingKeywords: string | undefined;
}

export const updateBlogPostBuilderKeywords = async (
  variables: Variables
): Promise<BlogPostBuilderBrief | undefined> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables: {
      ...variables,
      supportingKeywords: stringifyIfPresent(variables.supportingKeywords),
    },
  });

  const parsedRes = getSingleProp<Response>(result.data);
  if (!parsedRes) {
    return undefined;
  }

  return {
    ...parsedRes,
    supportingKeywords: parseJson<KeywordData[]>(parsedRes.supportingKeywords),
  };
};
